import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Listen(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.004 15.536A82.13 82.13 0 003.03 18.6c-.006.38.086 1.327.594 1.845.272.278.647.412 1.149.412.503 0 .897-.098 1.14-.286.059-.087.055-.297.052-.45l-.003-3.584a1 1 0 00-1-1H3.004zm15.883 0a1 1 0 00-1 1l-.003 3.584c-.003.153-.007.364.016.423.278.215.672.313 1.176.313.502 0 .877-.134 1.149-.412.508-.518.6-1.465.593-1.786.032-1.054.034-2.098.027-3.122h-1.958zm.189 7.32c-.963 0-1.758-.236-2.362-.702-.856-.657-.84-1.508-.83-2.07l.003-3.548c0-1.654 1.346-3 3-3h1.939c-.005-.506-.008-1.012-.008-1.517 0-.613-.068-1.244-.201-1.876-.37-1.744-1.182-3.365-2.29-4.564-1.105-1.196-2.556-2.028-4.197-2.406-.006 0-.951-.167-2.211-.173a14.14 14.14 0 00-2.242.182A8.143 8.143 0 005.522 5.58C4.414 6.777 3.6 8.4 3.232 10.143a9.04 9.04 0 00-.202 1.876c0 .505-.003 1.011-.007 1.517h1.939c1.654 0 3 1.346 3 3l.003 3.548c.01.562.025 1.413-.832 2.071-.603.465-1.398.701-2.36.701-1.045 0-1.941-.354-2.591-1.026C1 20.61 1.025 18.801 1.03 18.6.984 17.174 1 15.667 1.016 14.21c.008-.732.014-1.462.014-2.192 0-.754.082-1.524.245-2.29.449-2.123 1.41-4.027 2.778-5.507 1.379-1.494 3.183-2.53 5.218-2.999.087-.016 1.172-.216 2.648-.223 1.486.007 2.572.207 2.617.215 2.076.477 3.88 1.513 5.26 3.007 1.369 1.481 2.329 3.385 2.778 5.507.162.768.244 1.538.244 2.29 0 .73.007 1.46.015 2.192.016 1.457.03 2.964-.016 4.451.007.14.03 1.948-1.15 3.168-.65.672-1.546 1.026-2.591 1.026z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoListen = React.memo(Listen);
export default MemoListen;